<template>
  <div>

    <Form ref="uploadForm" :label-width="100" :model="uploadFormData" inline>
      <FormItem prop="company_id" label="所属车队">
        <Select v-model="uploadFormData.company_id" filterable>
          <Option v-for="item in companys" :value="item.company_id" :key="item.company_id">{{item.company_name}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="task_time" label="执行时间">
        <DatePicker v-model="uploadFormData.task_time" type="datetime" style="width: 200px" clearable></DatePicker>
      </FormItem>
      <FormItem :label-width="0">
        <Button type="primary" @click="downDemo">下载模板</Button>
      </FormItem>
      <FormItem :label-width="0">
        <Upload :action="apiPath + '/admin/company/addCompanyStationFileTask'"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :on-remove="handleRemove"
                :before-upload="beforeUpload"
                :format="['xlsx']"
                :max-size="5120"
                :on-format-error="formatError"
                :on-exceeded-size="exceededSize"
                :show-upload-list=false
                :data="uploadFormData"
                :headers="uploadHeader"
        >
          <Button icon="ios-cloud-upload-outline" type="primary">上传Excel</Button>
        </Upload>
      </FormItem>
       <FormItem  :label-width="0">
         <Button type="warning" @click="refreshTable">刷新</Button>
       </FormItem>

    </Form>


    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="{}"
               :showSearchForm="false"
               tableApi="admin/company/getCompanyStationTask"
    >
    </pageTable>

    <Drawer :title="companyStationModal.company_name" width="1000"
            :value="companyStationModal.isShow"
            :mask-closable="true"
            @on-close="companyStationModal.isShow=false">
      <CompanyStation :task-id="companyStationModal.task_id" v-if="companyStationModal.isShow"></CompanyStation>
    </Drawer>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import config from '@/config/base-config'
  import CompanyStation from "./companyStationPrice";
  export default {
    name: "fleet",
    components:{pageTable,CompanyStation},
    data() {
      return {
        companys: [],
        uploadFormData:{
          company_id:'',
          task_time:'',
        },
        tableColumn: [
          {title: 'ID',key: 'task_id',align: "center"},
          {title: '公司名称',key: 'company_name',align: "center"},
          {title: '数量',key: 'total_num',align: "center"},
          {title: '执行时间',key: 'task_time',align: "center"},
          {title: '上传时间',key: 'create_time',align: "center"},
          {title: '状态',key: 'status_name',align: "center"},
          {title: '操作',align: "center",width:220,render:(h,params)=>{
            let content = [];
            content.push(
                h('Button',{
                  props: {type: 'primary', size: 'small'},
                  on: {click: () => {this.showDetail(params.row)}}
                }, '查看'),
            )
              if (params.row.status===1){
                content.push(
                    h('Button',{
                      props: {type: 'error', size: 'small'},
                      on: {click: () => {this.del(params.row.task_id)}}
                    }, '删除'),
                )
              }

            return h('div',content)
          }},
        ],
        tableData: [],
        companyStationModal:{
          isShow:false,
          task_id:0,
          company_name: '',
        },
        apiPath:config.API_PATH,
        uploadHeader:{token:sessionStorage.getItem('token')}
      }
    },
    methods: {
      refreshTable(){
        this.$refs.table.getLists()
      },
      uploadSuccess(res,file){
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg)
          this.$refs.table.getLists()
        })
        // this.tableData = res.data
      },
      handleRemove (file) {
        const fileList = this.$refs.upload.fileList;
        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        this.proofs.splice(fileList.indexOf(file), 1)
      },
      uploadError(){
        this.$commonFun.errorTip('上传失败请重试')
      },
      formatError(){
        this.$commonFun.errorTip('文件格式不正确')
      },
      exceededSize(){
        this.$commonFun.errorTip('文件大小不能超过2M')
      },
      beforeUpload(){
      },
      showDetail(info){
        this.companyStationModal.isShow = true
        this.companyStationModal.task_id = info.task_id
        this.companyStationModal.company_name = info.company_name
      },
      async del(task_id){
        this.$Modal.confirm({
          title:'删除',
          content:`确定要删除该任务吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/company/delCompanyStationTask',{task_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })

      },
      downDemo(){
        window.open(config.API_PATH+'static/车队价格导入模板.xlsx');
      },
    },
    mounted() {
      this.$commonFun.postProxy('admin/company/getAllCompany',{}).then((res)=>{
        this.companys = res.data
      })
    },
  }
</script>

<style scoped>

</style>
